import React, { useState } from "react";
import "./id-card-config.scss";
import ConductCertificate from "./ConductCertificate";
import BonafideCertificate from "./BonafideCertificate";
import TransferCertificate from "./Transfercertificate";
import StudyCertificate from "./StudyCertificate";
import CharacterCertificate from "./CharacterCertificate";
// import schoolLogo from "../assets/school-logo.png";


const CertificateConfig = () => {
// conducted certificate start

// conducted certificate end

    const students = [
        {
            name: "U. Sathvika",
            guardian: "U. Raviteja",
            admission: "252628",
            dob: "09 Feb 2021",
            contact: "7893077007",
            className: "PP-1",
            section: "A"
        },

        {
            name: "Rahul Kumar",
            guardian: "Ramesh Kumar",
            admission: "252629",
            dob: "15 Jan 2020",
            contact: "9876543210",
            className: "1st",
            section: "B"
        }

    ];
    const [search, setSearch] = useState("");
    const [showList, setShowList] = useState(false);
    const [formData, setFormData] = useState({
        certificateType: "Bonafide Certificate",
        academic_year: "",
        curriculum: "",
        className: "",
        section: "",
        student: "",
        fatherName: "",
        admissionNo: "",
        dob: "",
        contactNo: "",
        issueDate: ""
    });

    const filteredStudents = students.filter((item) =>
        item.name.toLowerCase()
            .includes(search.toLowerCase())
    );

    const selectStudent = (student) => {
        setFormData(prev => ({
            ...prev,
            student: student.name,
            fatherName: student.guardian,
            admissionNo: student.admission,
            dob: student.dob,
            contactNo: student.contact,
            // only fill if student has values
            className: student.className || prev.className,
            section: student.section || prev.section
        }));
        setSearch(student.name);
        setShowList(false);
    }

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value

        })
    }

    const displayValue = (value) => {
        return value && value.trim() !== ""
            ? value
            : "________";
    }

    return (

        <div className="container-fluid">
            <div className="no-print">
                <div className="card">


                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-3">
                                <label>Certificate Type</label>

                                <select
                                    className="form-select"
                                    name="certificateType"
                                    value={formData.certificateType}
                                    onChange={handleChange}
                                >
                                    <option value="">select</option>
                                    <option value="BonafideCertificate">Bonafide Certificate</option>
                                    <option value="CharacterCertificate">Character Certificate</option>
                                    <option value="ConductCertificate">Conduct Certificate</option>
                                    <option value="StudyCertificate">Study Certificate</option>
                                    <option value="TransferCertificate">Transfer Certificate</option>
                                </select>
                            </div>
                           
                        </div>
                    </div>
                </div>
            </div>

            {
                formData.certificateType === "BonafideCertificate" && (
                    <>
                      <BonafideCertificate/>
                    </>
                )
            }

            {
                formData.certificateType === "ConductCertificate" && (
                    <>
                        <ConductCertificate />
                    </>
                )
            }
            {
                formData.certificateType === "CharacterCertificate" && (
                    <>
                        <CharacterCertificate />
                    </>
                )
            }
            {
                formData.certificateType === "StudyCertificate" && (
                    <>
                        <StudyCertificate/>
                    </>
                )
            }
            {
                formData.certificateType === "TransferCertificate" && (
                    <>
                        <TransferCertificate/>
                    </>
                )
            }


        </div>

    )

}

export default CertificateConfig;